<template>
  <div :class="['dep-tree', adminMode ? 'dep-tree--admin' : '', shortMode ? 'dep-tree--short' : '']">
    <div class="dep-tree__row dep-tree__row--head">
      <div class="dep-tree__cell dep-tree__cell--head">
        {{ $t('labels.name1') }}
      </div>
      <div v-if="!shortMode" class="dep-tree__cell dep-tree__cell--head">
        {{ $t('orgs.name_short') }}
      </div>
      <div v-if="adminMode" class="dep-tree__cell dep-tree__cell--head">
        {{ $t('labels.actions') }}
      </div>
    </div>
    <template>
      <custom-el-tree
        :data="depList"
        :props="treeProps"
        :expand-on-click-node="true"
        node-key="id"
        :draggable="editMode"
        :defaultExpandedKeys="rootKeys"
        :indent="36"
        @node-drag-end="parentChanged">
        <div class="dep-tree__row" slot-scope="{ node }">
          <div class="dep-tree__cell">{{node.data.name}}</div>
          <div class="dep-tree__cell" v-if="!shortMode">{{node.data.abbr}}</div>
          <div v-if="adminMode" class="dep-tree__cell">
            <drop-down-menu :node="node" @deleteOrg="deleteOrg"></drop-down-menu>
          </div>
          <div class="dep-tree__cell">
            <router-link :to="{ name: 'orgPage', params: { id: node.data.id } }" class="dep-tree__link">
              <span>{{ $t('labels.more') }}</span>
            </router-link>
          </div>
          <div v-if="editMode" class="dep-tree__edit-marker">
            <span></span>
          </div>
        </div>
      </custom-el-tree>
    </template>
  </div>
</template>
<script>
  // import org from 'src/api/org'
  // import getDepartmentList from '@/services/departmentList'
  import customElTree from './src/tree.vue'
  // import chiefName from './chiefName.vue'
  import dropDownMenu from './dropDownMenu.vue'

  export default {
    props: {
      depList: {
        type: Array,
        default () { return [] }
      },
      adminMode: {
        type: Boolean,
        default: false
      },
      shortMode: {
        type: Boolean,
        default: false
      },
      editMode: {
        type: Boolean,
        default: false
      }
    },
    components: {
      customElTree,
      // chiefName,
      dropDownMenu
    },
    data () {
      return {
        treeProps: {
          children: 'children',
          label: 'name',
          disabled: 'disabled'
        }
      }
    },
    methods: {
      parentChanged (child, parent, dragType) {
        this.$emit('parentChanged', child, parent)
      },
      async deleteOrg (id, name) {
        let children = await this.$store.dispatch('orgs/byParent', id)
        if (children && children.length) {
          this.$notify({
            // @ts-ignore
            title: this.$t('labels.error'),
            message: this.$t('orgs.can_not_delete_org_with_subdivision'),
            type: 'warning',
            offset: 75,
            duration: 10000
          })
        } else {
          this.$confirm(name, `${this.$t('orgs.subdivision_delete')}?`, {
            confirmButtonText: this.$t('labels.delete'),
            cancelButtonText: this.$t('labels.cancel'),
            customClass: 'delete-modal'
          }).then(() => {
            this.$store.dispatch('orgs/removeOrg', id).then(data => {
              this.$message({
                type: 'success',
                message: this.$t('orgs.subdivision_deleted')
              });
              this.$emit('updateData')
            }).catch(() => {
              this.$message({
                type: 'warning',
                message: this.$t('orgs.delete_error')
              });
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              // @ts-ignore
              message: this.$t('employees.delete_canceled')
            });
          });
        }
      }
    },
    computed: {
      rootKeys () {
        let ids = []
        for (let org of this.depList) {
          ids.push(org.id)
        }
        return ids
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.dep-tree {
  min-width: 850px;

  &--admin {
    .dep-tree {

      &__row {
        grid-template-columns: 1fr 130px 150px 90px;
      }
    }
  }

  &--short {
    .dep-tree {

      &__row {
        grid-template-columns: 1fr 90px;
      }
    }
  }

  &__row {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 160px 90px;
    justify-content: end;
    align-items: center;
    grid-column-gap: 20px;
    width: 100%;
    padding: 22px 22px 22px 22px;
    cursor: default;

    &--head {
      padding: 14px 22px 14px 36px;
      align-items: center;
      border-bottom: 1px solid $base-border-color;
    }
  }

  &__cell {
    white-space: normal;
    word-break: break-word;
    &--head {
      color: $secondary-font-color;
    }
  }

  &__link {
    color: $link-color;
    padding-right: 15px;

    &:hover {
      color: $link-color-hover;
    }
  }

  &__edit-marker {
    position: absolute;
    right: 0;
    top: 0;
    width: 29px;
    height: 100%;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 16px 0;
    background: #E4E7ED;
    cursor: pointer;

    span {
      display: block;
      background: #C0C4CC;
      width: 3px;
    }

    &:hover {
      background: #1989FA;

      span {
        background: #fff;
      }
    }
  }

  .el-tree {
    &__drop-indicator {
      display: none !important;
      height: 3px;
      background: #1989FA;
    }
  }

  .el-tree-node {
    &.is-drop-inner {
      background: #ecf5ff;
    }
  }

  .el-tree-node__content {
    position: relative;
    height: auto;
    border-bottom: 1px solid $base-border-color;
  }

  .el-tree-node__expand-icon {
    z-index: 1;
    cursor: pointer;

    position: relative;
    margin-top: 0;
    top: auto;
    padding: 0;
    font-size: 16px;
    font-weight: bold;
    &.expanded {
      color: #1989FA;
    }
    &.is-leaf {
      padding: 0px;
      width: auto;
    }
    &:before {
      content: "\E604";
    }
  }
}

.dep-tree-dropdown-menu {
  padding-left: 15px;

  &:focus {
    outline: 0;
  }

  .el-dropdown-link {
    outline: none;
  }

  &__item {
    a {
      display: grid;
      grid-template-columns: 24px 1fr;
      grid-column-gap: 12px;

      &:hover {
        color: #2F80ED !important;
      }
    }
  }

  &__item-icon {
    text-align: center;
  }

  &__drop-icon {
    color: #C0C4CC;
    font-size: 20px;

    &:focus {
      outline: 0;
      border: none;
    }
  }
}
</style>